/**
* When a form is loaded, enable any help text that appears on the page.
*/
define('controllers/helpText',[], function() {
	var controller = Marionette.Object.extend( {
		initialize: function() {
			this.listenTo( nfRadio.channel( 'form' ), 'render:view', this.initHelpText );

			nfRadio.channel( 'form' ).reply( 'init:help', this.initHelpText );
		},

		initHelpText: function( view ) {
			jQuery( view.el ).find( '.nf-help' ).each( function() {
			jQuery(this).attr('tabindex', '0'); // Make the element keyboard focusable
				var jBox = jQuery( this ).jBox( 'Tooltip', {
					theme: 'TooltipBorder',
					content: jQuery( this ).data( 'text' ),
					trigger: 'mouseenter focus',
					closeOnMouseleave: true
				});
			// Hide tooltip on focusout and mouseleave
			jQuery(this).on('focusout mouseleave', function() {
				jBox.close();
			});
			} );
		}
	});

	return controller;
 } );
